export const COMPANY = {
  name: "MDN SERVICE SRL",
  brand: "Madonna Store",
  address: "Via G. Rossini, 22 – 80128 Napoli (NA)",
  vat: "10054501217",
  email: "info@madonna-store.it",
  pec: "mdn.servicesrl@pec.it",
};

const KEY = "ms_cookie_consent";
export const CONSENT_VERSION = 1;

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c?.v === CONSENT_VERSION ? c : null;
  } catch {
    return null;
  }
};

export const saveConsent = (prefs) => {
  localStorage.setItem(KEY, JSON.stringify({ v: CONSENT_VERSION, necessary: true, ...prefs, at: new Date().toISOString() }));
  window.dispatchEvent(new Event("cookie-consent-changed"));
};

export const openCookiePrefs = () => window.dispatchEvent(new Event("open-cookie-prefs"));
